import { emitScrollEvent } from '@accedo/virtual-scroll';
import { nav } from '##/init';

export const scrollThenFocus = (
  scrollNavId: string,
  scrollPosition: number,
  focusId: string,
): void => {
  emitScrollEvent('scroll-primary-to-index', scrollPosition, scrollNavId);
  const afterScroll = (): void => {
    nav.assignFocus(focusId);
    window.removeEventListener('post-virtual-scroll', afterScroll);
  };
  window.addEventListener('post-virtual-scroll', afterScroll);
};
